import { Component, EventEmitter, Input, Output } from '@angular/core';
import { WidgetInstanceModel } from 'src/app/shared/models/widget.model';
import { WidgetUIType } from 'src/app/shared/models/widget.type';

@Component({
  selector: 'app-home-widget-card',
  templateUrl: './home-widget-card.component.html',
  standalone: false
})
export class HomeWidgetCardComponent {
  @Input() widget: WidgetInstanceModel;
  @Output() addTeam = new EventEmitter<void>();

  readonly WidgetUIType = WidgetUIType;
}
